import createKindeClient, {
  type KindeClient,
} from "@kinde-oss/kinde-auth-pkce-js";

export type KindeUser = {
  email?: string;
  given_name?: string;
  family_name?: string;
  id?: string;
};

const DOMAIN = import.meta.env.VITE_KINDE_DOMAIN as string;
const CLIENT_ID = import.meta.env.VITE_KINDE_CLIENT_ID as string;
const AUDIENCE = (import.meta.env.VITE_KINDE_AUDIENCE as string) || "trading-server-api";

let _client: KindeClient | null = null;

export async function client(): Promise<KindeClient> {
  if (_client) return _client;
  _client = await createKindeClient({
    client_id: CLIENT_ID,
    domain: DOMAIN,
    audience: AUDIENCE,
    redirect_uri: window.location.origin,
    logout_uri: window.location.origin,
    is_dangerously_use_local_storage: true,
  });
  return _client;
}

export async function login() {
  const c = await client();
  await c.login();
}

export async function logout() {
  const c = await client();
  await c.logout();
}

export async function getToken(): Promise<string | undefined> {
  const c = await client();
  return c.getToken();
}

export async function isAuthed(): Promise<boolean> {
  const c = await client();
  return c.isAuthenticated();
}

export async function getUser(): Promise<KindeUser | undefined> {
  const c = await client();
  return (await c.getUser()) as KindeUser | undefined;
}
